import { MapPlatformToName } from './types.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class VrioOttError extends Error {
  constructor(message, options, errorConstructor) {
    super(message, { cause: options.cause });
    __publicField(this, "name", "VrioOttError");
    __publicField(this, "source");
    __publicField(this, "platform");
    __publicField(this, "location");
    __publicField(this, "code");
    __publicField(this, "externCode");
    __publicField(this, "timestamp");
    __publicField(this, "data");
    this.timestamp = Date.now();
    this.source = options.source;
    this.platform = options.platform;
    this.location = options.location;
    this.code = options.code;
    this.externCode = options.externCode === void 0 ? void 0 : `${options.externCode}`;
    this.data = options.data;
    if (!this.stack) {
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, errorConstructor || this.constructor);
      } else {
        try {
          throw new Error("Stack generator");
        } catch (error) {
          this.stack = error.stack;
        }
      }
    }
  }
  get userCode() {
    let fullCode = `${this.source}${this.platform}-${this.location}${this.code}`;
    if (this.externCode !== void 0) {
      fullCode += ` (${this.externCode})`;
    }
    return fullCode;
  }
  get platformName() {
    return MapPlatformToName[this.platform];
  }
  toString() {
    return `VrioOttError: ${this.userCode}
${this.stack}`;
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      stack: this.stack,
      cause: this.cause,
      timestamp: new Date(this.timestamp).toISOString(),
      data: this.data
    };
  }
}

export { VrioOttError };
//# sourceMappingURL=VrioOttError.js.map
